/**
 * Frontend mirror of OpenTalents.Domain.Entities.Subscriptions.EntitlementKeys
 * Keep in sync with the backend constant class.
 *
 * @userstory US-ENT-01, US-ENT-02, US-ENT-03
 */
export const EntitlementKeys = {
	Capabilities: {
		PremiumModel: 'org.premium_model',
		InsightsAdvanced: 'org.insights_advanced',
		Sso: 'org.sso',
		AtsIntegration: 'org.ats_integration',
	},
	Quotas: {
		AiCreditsPerMonth: 'org.ai_credits_per_month',
		PublicNeedsActive: 'org.public_needs_active',
		Seats: 'org.seats',
		MonitorSlots: 'org.monitor_slots',
	},
	AddOns: {
		FreelanceManagement: 'addon.freelance_management',
	},
	TalentCapabilities: {
		VideoPitch: 'talent.video_pitch',
		MarketInsights: 'talent.market_insights',
		ProfilePresentationBoost: 'talent.profile_presentation_boost',
	},
	TalentQuotas: {
		PeerSearchesPerMonth: 'talent.peer_searches_per_month',
	},
} as const;
